<template>
  <v-container class="tourist-scan-page" fluid v-if="hasAccessToPage">
    <v-row justify="start" class="mx-4">
      <v-col cols="12" sm="12" md="12" lg="12" xl="11">
        <ScanInputCard
          :autoFocus="autofocus"
          :disableScanInput="disableScanInput"
          :caseId="searchedPatientCaseId"
          :inputId="scanTextInputId"
          :primarySubject="primarySubject"
          :dataDisplayed="dataDisplayed"
          @setScannedWithMobileDevice="setScannedWithMobileDevice"
          v-on:displaySubjectData="displaySubjectData"
          v-on:setTestTubeKitInfoToNull="setToNull"
          v-on:hideLoadProgress="hideLoadProgress"
          v-on:resetAllData="resetAllData"
          v-on:setTestTubeMessage="setTestTubeMsg"
          v-on:focusScanInput="focusScanInput"
          v-on:printLinkedSubjectInfo="printLinkedSubjectInfo"
          v-on:displayTestTubeData="displayTestTubeData"
        />
      </v-col>
    </v-row>
    <v-row class="mt-8 ml-4 mr-4" justify="start">
      <v-col cols="12" sm="12" md="4" lg="4" xl="3">
        <PatientCaseCards :subjectRelations="subjectRelations" :loadProgress="loadProgress" :primarySubject="primarySubject" />
      </v-col>
      <v-col cols="12" sm="12" md="5" lg="5" xl="5">
        <SelectedCase
          :primarySubject="primarySubject"
          :untrusted="untrusted"
          :dbz="dbz"
          :undocumented="undocumented"
          :disableScanQrCode="disableScanQrCode"
          :linkEDCardNr="linkEDCardNr"
        />
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3" xl="3">
        <TestTubeInfo :testTubeKitInfo="testTubeKitInfo" :testTubeMessage="testTubeMessage" />
      </v-col>
    </v-row>

    <SelectedCaseForm v-if="editPrimarySubject" :showModal="editPrimarySubject" :formDataParent="primarySubject" @caseUpdated="caseUpdated" />

    <!-- comment modal if linked within 24 hours -->
    <LinkedCaseCommentModal v-if="showCommentModal" :pay="pay" :showCommentModal="showCommentModal" />

    <!-- payment method modal -->
    <PaymentMethodModal
      v-if="showPaymentMethodModal"
      :showPaymentMethodModal="showPaymentMethodModal"
      @submitPaymentMethodParent="submitPaymentMethod"
    />

    <!-- print subject after link -->
    <PrintLinkedCase v-if="linkedUser" id="printLinkedCaseAuto" :linkedUser="linkedUser" :lastScannedBarcode="lastScannedBarcode" />

    <!-- link ED card -->
    <LinkEDCard v-if="showEDCardDialog" :showEDCardDialog="showEDCardDialog" :disableScanQrCode="disableScanQrCode" />

    <!-- search account and fill scan input with case id -->
    <AccountSearchModal :showModal="showAccountSearchModal" />
  </v-container>
  <NoAccessMessage v-else />
</template>

<script>
import AccountSearchModal from '@/components/AccountSearchComponent/account-search-modal';
import SelectedCaseForm from '@/views/TestTubeLinkPage/components/SelectedCase/components/SelectedCaseForm';
import ScanInputCard from '@/views/TestTubeLinkPage/components/ScanInputCard/ScanInputCard.vue';
import SelectedCase from '@/views/TestTubeLinkPage/components/SelectedCase/SelectedCase.vue';
import PatientCaseCards from '@/views/TestTubeLinkPage/components/PatientCaseCards.vue';
import TestTubeInfo from '@/views/TestTubeLinkPage/components/TestTubeInfo.vue';
import '@/assets/scss/test-tube-link-generic.scss';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';
import PrintLinkedCase from '@/views/TestTubeLinkPage/components/PrintLinkedCase.vue';
import LinkedCaseCommentModal from '@/views/TestTubeLinkPage/components/LinkedCaseCommentModal.vue';
import PaymentMethodModal from '@/views/TestTubeLinkPage/components/PaymentMethodModal.vue';
import LinkEDCard from '@/views/TestTubeLinkPage/components/LinkEDCard.vue';
import moment from 'moment';

export default {
  mixins: [SharedFunctions],
  components: {
    AccountSearchModal,
    ScanInputCard,
    SelectedCase,
    SelectedCaseForm,
    PatientCaseCards,
    TestTubeInfo,
    NoAccessMessage,
    PrintLinkedCase,
    LinkedCaseCommentModal,
    PaymentMethodModal,
    LinkEDCard
  },
  data() {
    return {
      autofocus: false,
      scanTextInputId: 'scanTextInput',
      showAccountSearchModal: false,
      primarySubject: null,
      editPrimarySubject: false,
      subjectRelations: [],
      testTubeKitInfo: null,
      testTubeMessage: null,
      intervalScanTime: 5000,
      loadProgress: null,
      scannedCaseId: null,
      disableScanInput: false,
      hasAccessToPage: false,
      intervalTimer: null,
      linkedUser: null,
      lastScannedBarcode: null,
      caseId: this.$route.params.caseId,
      untrusted: false,
      dbz: false,
      undocumented: false,
      tags: {
        undocumented: false,
        paymentMethod: false,
        edCardNr: null
      },
      tagsPrestine: null,
      showCommentModal: false,
      showPaymentMethodModal: false,
      withinHoursShowComment: 24,
      pay: null,
      scannedWithMobileDevice: false,
      showEDCardDialog: false,
      disableScanQrCode: false,
      linkEDCardNr: null
    };
  },
  computed: {
    dataDisplayed() {
      return this.primarySubject ? true : false;
    },
    searchedPatientCaseId() {
      return this.getPatientCaseId(); // ?? this.$route.params.caseId;
    },
    saveButtonDisabled() {
      return this.testTubeKitInfo && this.testTubeKitInfo.data && this.testTubeKitInfo.data == 'NOT_FOUND' ? false : true;
    }
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
    this.tagsPrestine = JSON.stringify(this.tags);

    // clears AccountSearchModal results
    this.$store.commit('accountSearchStore/SET_SEARCHED_ACCOUNTS', []);
    this.$store.commit('accountSearchStore/SET_ACCOUNT_SEARCHED_QUERY', null);
  },
  mounted() {
    // this.focusScanInput();
    this.caseId = this.$route.params.caseId;
  },
  beforeDestroy() {
    clearTimeout(this.intervalTimer);
    this.resetAllData();
  },
  methods: {
    async caseUpdated() {
      let subjectData = await this.$store.dispatch('testTubeLinkStore/getVisitorSubjectData', this.scannedCaseId);
      for (var i = 0; i < subjectData.length; i++) {
        if (subjectData[i].patientCaseId == this.primarySubject.patientCaseId) {
          this.primarySubject = subjectData[i];
        }
      }
    },
    toggleEditCaseDialog() {
      this.editPrimarySubject = !this.editPrimarySubject;
    },
    getPatientCaseId() {
      var pCaseId = this.$store.state.testTubeLinkStore.currentPatientCaseId;

      this.$store.commit('testTubeLinkStore/SET_CURRENT_PATIENT_CASE_ID', undefined); // patientcase reset to prevent reloading state when opening visitorscanpage.
      return pCaseId ?? this.caseId;
    },
    hideLoadProgress() {
      this.loadProgress = false;
    },
    toggleShowAccountSearchModal() {
      this.showAccountSearchModal = !this.showAccountSearchModal;
    },
    displaySubjectData(subjectData, scannedCaseId) {
      this.primarySubject = subjectData.filter((subject) => subject.patientCaseId == scannedCaseId)[0];
      this.subjectRelations = subjectData;
      this.scannedCaseId = scannedCaseId;
      this.linkEDCardNr = null;
      if (!this.scannedWithMobileDevice) {
        this.focusScanInput();
      } else {
        this.$store.commit('SET_SNACKBAR', { open: true, text: 'QR code successfully scanned', color: 'green' });
        this.scannedWithMobileDevice = false;
      }

      this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
      //this.initIntervalScan(true); // stopped because of performance issues
    },
    async initIntervalScan(firstTime) {
      if (!firstTime) {
        clearTimeout(this.intervalTimer);
        const subjectData = await this.$store.dispatch('testTubeLinkStore/getVisitorSubjectData', this.scannedCaseId);
        this.loadProgress = false;
        //display data only if scanned input matches id in subjects array, in case of slow call returns
        if (subjectData.filter((subject) => subject.patientCaseId == this.scannedCaseId)[0]) {
          this.primarySubject = subjectData.filter((subject) => subject.patientCaseId == this.scannedCaseId)[0];
          this.subjectRelations = subjectData;
          setTimeout(() => (this.loadProgress = true), 0);
        }
      } else {
        setTimeout(() => (this.loadProgress = true), 0);
      }
      this.intervalTimer = setTimeout(() => {
        if (this.dataDisplayed) this.initIntervalScan(false);
      }, this.intervalScanTime);
    },
    displayTestTubeData(data, input) {
      if (data == 'NOT_FOUND') {
        this.testTubeMessage = null;
        this.disableScanInput = true;
        this.testTubeKitInfo = { data: data, input: input };
      } else {
        this.disableScanInput = false;
        this.testTubeMessage = 'Test tube already taken, please scan another one';
        this.testTubeKitInfo = null;
      }
      if (!this.scannedWithMobileDevice) {
        this.focusScanInput();
      } else {
        if (this.testTubeMessage) {
          this.$store.commit('SET_SNACKBAR', { open: true, text: this.testTubeMessage, color: 'warning' });
        } else {
          this.$store.commit('SET_SNACKBAR', { open: true, text: 'Test tube successfully scanned', color: 'green' });
        }
        this.scannedWithMobileDevice = false;
      }
    },
    setTestTubeMsg(msg) {
      this.testTubeMessage = msg;
    },
    selectRelationCard(subject) {
      this.primarySubject = subject;
      this.editPrimarySubject = false;
      this.scannedCaseId = subject.patientCaseId;
      this.testTubeMessage = null;
      this.tags.edCardNr = null;
      this.linkEDCardNr = null;
    },
    setToNull() {
      this.testTubeKitInfo = null;
    },
    async initLinkSubjectToTestTube(pay) {
      //if first tube scanned link else check if done within 24 hours
      const testKitData = await this.$store.dispatch('testTubeLinkStore/getPatientTestKitInfo', this.scannedCaseId);
      if (testKitData.length == 0) {
        this.linkSubjectToTestTube(pay);
        return;
      }

      //check if already has tube scanned within 24 hours
      const lastTestKit = testKitData.pop();
      const lastTestKitDateTime = moment.utc(lastTestKit.registerDate, 'YYYY-MM-DDTHH:mm').local();
      const hoursSinceLastLinkedKit = moment().utc().diff(lastTestKitDateTime, 'hours');
      if (hoursSinceLastLinkedKit < this.withinHoursShowComment) {
        //set props
        this.pay = pay;
        this.showCommentModal = true;
      } else {
        this.linkSubjectToTestTube(pay);
      }
    },
    linkSubjectToTestTube(pay, comment = null) {
      let trusted = this.untrusted ? false : true;
      //if pay is false, clean up payment method
      if (!pay) this.updateTag('paymentMethod', false);

      let postBody = {
        testKitBarcode: this.testTubeKitInfo.input,
        pay: pay.toString(),
        trusted: trusted.toString(),
        dbz: this.dbz.toString(),
        tags: JSON.stringify(this.tags),
        comment: comment
      };

      this.$store.dispatch('testTubeLinkStore/linkSubjectToTestTube', { caseId: this.scannedCaseId, body: postBody }).then((data) => {
        if (data) {
          //reset modal if visible
          this.showCommentModal = false;
          //update view manually
          this.subjectRelations.forEach((subject) => {
            if (subject.patientCaseId == this.primarySubject.patientCaseId) subject.patientTestKit.push({ number: this.testTubeKitInfo.input });
          });
          //print if dashboard user has role
          if (this.$store.getters.userObject.roles.includes('mobile_scan')) {
            this.printLinkedSubjectInfo(data, this.testTubeKitInfo.input);
          } else {
            this.linkedUser = null;
          }

          //reset data
          this.resetDataAfterLinkCreated();
        }
      });
    },
    focusScanInput() {
      setTimeout(() => {
        var el = document.getElementById(this.scanTextInputId);
        el.focus();
      }, 0);
    },
    resetAllData() {
      this.subjectRelations = [];
      this.primarySubject = null;
      this.testTubeKitInfo = null;
      this.disableScanInput = false;
      this.scannedCaseId = null;
    },
    resetDataAfterLinkCreated() {
      this.testTubeKitInfo = null;
      this.disableScanInput = false;
      this.dbz = false;
      this.undocumented = false;
      this.untrusted = false;
      this.linkEDCardNr = null;
      this.tags = JSON.parse(this.tagsPrestine);
      this.focusScanInput();
    },
    printLinkedSubjectInfo(data, lastScannedBarcode) {
      this.linkedUser = data;
      this.lastScannedBarcode = lastScannedBarcode;
      this.savePrintItemLocalStorage(data, lastScannedBarcode);
      setTimeout(() => {
        this.$htmlToPaper('printLinkedCaseAuto', null, () => {
          this.focusScanInput();
          this.linkedUser = null;
        });
      }, 400);
    },
    updateDBZ(value) {
      this.dbz = value;
    },
    updateUndocumented(value) {
      this.undocumented = value;
      this.updateTag('undocumented', value);
    },
    updateTag(key, value) {
      this.$set(this.tags, key, value);
    },
    updateUntrusted(value) {
      this.untrusted = value;
    },
    savePrintItemLocalStorage(data, lastScannedBarcode) {
      const dataToSave = {
        data,
        lastScannedBarcode
      };
      localStorage.setItem('hohApp_lastLinkedSubject', JSON.stringify(dataToSave));
    },
    submitPaymentMethod(value) {
      this.updateTag('paymentMethod', value);
      this.initLinkSubjectToTestTube(true);
    },
    setScannedWithMobileDevice(value) {
      this.scannedWithMobileDevice = value;
    },
    linkEDCardModal() {
      this.showEDCardDialog = true;
    },
    updateEDCardId(value) {
      this.linkEDCardNr = value;
      this.updateTag('edCardNr', value);
    }
  }
};
</script>
